// This is coming from `runtime-config.js`.
declare global {
  interface Window {
    PLATFORM_BASE?: string;
    DOCS_BASE?: string;
  }
}

// Links inside a project carry the data snapshot id, so that opening them in
// a new tab stays within the snapshot. `project-context` consumes the param and
// strips it from the address bar.
export const SNAPSHOT_ID_PARAM = 'snapshot_id';

export function projectPlatformUrl(path: string, search: URLSearchParams | undefined, snapshotId: string | undefined): string {
  search ??= new URLSearchParams();
  if (snapshotId)
    search.set(SNAPSHOT_ID_PARAM, snapshotId);
  return platformUrl(path, search);
}

export function platformUrl(path: string, search?: URLSearchParams): string {
  const raw = window.PLATFORM_BASE ?? window.location.href;
  const base = raw.endsWith('/') ? raw.slice(0, -1) : raw;
  if (search && search.size)
    path = path + '?' + search.toString();
  return new URL(path, base).href;
}

export function docsUrl(path: string): string {
  const raw = window.DOCS_BASE ?? 'https://docs.flakiness.io';
  const base = raw.endsWith('/') ? raw.slice(0, -1) : raw;
  return base + path;
}